import { render, staticRenderFns } from "./PatchDomain.vue?vue&type=template&id=05cda098&scoped=true"
import script from "./PatchDomain.vue?vue&type=script&lang=js"
export * from "./PatchDomain.vue?vue&type=script&lang=js"
import style0 from "./PatchDomain.vue?vue&type=style&index=0&id=05cda098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cda098",
  null
  
)

export default component.exports